import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from '../../../services/api.service';

declare const $;

@Component({
  selector: 'pm-sign-in-up-form',
  templateUrl: './sign-in-up-form.component.html',
  styleUrls: ['./sign-in-up-form.component.scss']
})
export class SignInUpFormComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() signIn = true;

  model = {};

  constructor(
    private router: Router,
    private api: ApiService
  ) {
  }

  ngAfterViewInit(): void {
    this.initScripts();

    $('#exampleModal').on('shown.bs.modal', (e) => {
      setTimeout(() => {
        $('#exampleModal').modal('hide');
        this.router.navigate(['/account']);
      }, 750);
    });
  }

  ngOnInit(): void {
    document.body.classList.add('Signing');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('Signing');
  }

  public async submit(): Promise<any> {
    try {
      const res = await this.api.signIn(this.model);
      if (res.done) {
        // signin success goes here
      }
    } catch (e) {
      console.error(e);
    }
  }

  initScripts(): void {
    function showPwd(): void {
      const p = document.getElementById('pwd');
      p.setAttribute('type', 'text');
    }

    function hidePwd(): void {
      const p = document.getElementById('pwd');
      p.setAttribute('type', 'password');
    }

    let pwShown = 0;

    document.getElementById('eye').addEventListener('click', () => {
      if (pwShown === 0) {
        pwShown = 1;
        showPwd();
      } else {
        pwShown = 0;
        hidePwd();
      }
    }, false);

    $(document).ready(() => {
      $('.forgot_click').click(() => {
        $('.for_remove').remove();
      });
      $('.vefiry_click').click(() => {
        $('.for_remove').remove();
      });
      if ($(window).width() > 991) {
        // footer fixed js
        $(document).ready(() => {
          const footerPadd = $('footer').height() + 'px';
          $('main').css('margin-bottom', footerPadd);
        });
      }
    });

    // parallax-scroll
    $(document).ready(() => {
      function show(): void {
        const pw = document.getElementById('sipwd');
        pw.setAttribute('type', 'text');
      }

      function hide(): void {
        const pw = document.getElementById('sipwd');
        pw.setAttribute('type', 'password');
      }

      let pwhown = 0;

      document.getElementById('sieye').addEventListener('click', () => {
        if (pwhown === 0) {
          pwhown = 1;
          show();
        } else {
          pwhown = 0;
          hide();
        }
      }, false);
    });
  }
}
